import { create } from "zustand";

const useLayoutStore = create((set) => ({
  isSidebarOpen: false,
  setSidebarMenuOpen: (isSidebarOpen) => set(() => ({ isSidebarOpen })),
}));

export default useLayoutStore;